import { ShiftingObstacle } from "./ShiftingObstacle";
import { ObstacleMapData } from "../ObstacleMapData";
import { ViewCellMapRow } from "../../View/ViewCellMapRow";
import { SoundManager } from "../../../../Utils/SoundManager";
import { eSfxSprite, SfxSprites, Game, eAudioAsset } from "../../../../Game";


export class FlyingObstacle extends ShiftingObstacle {
    /**
     * Zmenseni stinu, pokud je prekazka uplne nahore
     */
    private static readonly SHADOW_MIN_SCALE = 0.5;

    private _topPyramid: pc.GraphNode;
    private _propellers: pc.GraphNode[];

    private static readonly _MIN_ROT_SPEED = 1;
    private static readonly _MAX_ROT_SPEED = 10;

    private static readonly _OPEN_PROPELLER_ANGLE = 0;
    private static readonly _CLOSED_PROPELLER_ANGLE = 70;

    /**
     * Pomer rotace horni casti pyramidy
     */
    private _rotSpeedRatio: number;

    /**
     * True, pokud se ma prehrat zvukovy efekt pro prekazku
     */
    private _playSfx: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super();

        SoundManager.addSoundSlot(this._entity, eSfxSprite.vertObsHit, SfxSprites[eSfxSprite.vertObsHit], Game.sfxSpriteAssetId);
        SoundManager.addSoundSlot(this._entity, eSfxSprite.vertObsUp, SfxSprites[eSfxSprite.vertObsUp], Game.sfxSpriteAssetId);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(mapData: ObstacleMapData, row: ViewCellMapRow): void {
        super.init(mapData, row);

        if (!this._topPyramid) {
            this._topPyramid = this._entity.findByName("topPyramid");
            this._propellers = [];

            for (let i = 0; i < 4; i++)
                this._propellers.push(this._entity.findByName("prop_" + i));
        }

        let propsAngle: number;

        if (this._settings.deadly) {
            // Prekazka spadne
            this._shadow.setLocalScale(FlyingObstacle.SHADOW_MIN_SCALE, FlyingObstacle.SHADOW_MIN_SCALE, 1);

            propsAngle = FlyingObstacle._OPEN_PROPELLER_ANGLE;
            this._rotSpeedRatio = 1;
        }
        else {
            // Prekazka vzletne
            propsAngle = FlyingObstacle._CLOSED_PROPELLER_ANGLE;
            this._rotSpeedRatio = 0;
        }

        // Nastavit zklopeni vrtuli        
        this._propellers.forEach((prop: pc.GraphNode) => {
            prop.setLocalEulerAngles(propsAngle, 0, prop.getLocalEulerAngles().z);
        });

        // Sfx
        this._playSfx = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (!super.update())
            return false;

        // Rotace
        this._topPyramid.rotateLocal(0, 0, FlyingObstacle._MIN_ROT_SPEED + this._rotSpeedRatio * (FlyingObstacle._MAX_ROT_SPEED - FlyingObstacle._MIN_ROT_SPEED));

        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected processShift(realProg: number, easedProg: number): void {
        super.processShift(realProg, easedProg);

        let deadly = this._settings.deadly;

        // Rychlost rotace
        this._rotSpeedRatio = (deadly ? 1 - realProg : pc.CubicOut(realProg));

        // Upravit nakopeni listu vrtule podle rychlosti rotace
        let angle = FlyingObstacle._CLOSED_PROPELLER_ANGLE + this._rotSpeedRatio * (FlyingObstacle._OPEN_PROPELLER_ANGLE - FlyingObstacle._CLOSED_PROPELLER_ANGLE);

        this._propellers.forEach((prop: pc.GraphNode) => {
            prop.setLocalEulerAngles(angle, 0, prop.getLocalEulerAngles().z);
        });

        // Stin
        if (!deadly)
            easedProg = 1 - easedProg;

        let scale = FlyingObstacle.SHADOW_MIN_SCALE + (1.1 - FlyingObstacle.SHADOW_MIN_SCALE) * easedProg;

        this._shadow.setLocalScale(scale, scale, 1);

        // Sfx
        if (this._playSfx) {
            if (!deadly) {
                this._playSfx = false;
                SoundManager.playSound(this._entity, eSfxSprite.vertObsUp);
            }
            else if (easedProg >= 0.8) {
                this._playSfx = false;
                SoundManager.playSound(this._entity, eSfxSprite.vertObsHit);
            }
        }
    }
}